import { render, staticRenderFns } from "./AgentProfile.vue?vue&type=template&id=a60b94fc&scoped=true&"
import script from "./AgentProfile.vue?vue&type=script&lang=ts&"
export * from "./AgentProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AgentProfile.vue?vue&type=style&index=0&id=a60b94fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60b94fc",
  null
  
)

export default component.exports